// Silent defaults · A-26 — the risk rating select and badge. An unrated field is "" = "Not assessed" (the select shows its
// placeholder; the badge reads "Not assessed"); the dialogs refuse a save until every rating is chosen. Rows stored "Medium"
// still read "Medium". (New component next to RiskAssessment.jsx — big-file rule.)
import React from "react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export const RISK_RATING_FIELDS = ["inherent_risk", "control_risk", "likelihood", "impact", "overall_rating"];
export const RISK_RATINGS = ["High", "Medium", "Low"];

export const isRating = (v) => RISK_RATINGS.includes(v);
export const missingRatings = (d) => RISK_RATING_FIELDS.filter((k) => !isRating(d?.[k]));
export const ratingsComplete = (d) => missingRatings(d).length === 0;

export function RiskRatingSelect({ value, onValueChange, t, testid }) {
  return (
    <Select value={isRating(value) ? value : ""} onValueChange={onValueChange}>
      <SelectTrigger data-testid={testid} data-rating={isRating(value) ? value : ""}>
        <SelectValue placeholder={t("sd.notAssessed")} />
      </SelectTrigger>
      <SelectContent>
        {RISK_RATINGS.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export function RatingBadge({ v, t }) {
  if (!isRating(v)) {
    return <span className="inline-flex rounded-md border px-2 py-0.5 text-xs text-muted-foreground" data-rating="">{t("sd.notAssessed")}</span>;
  }
  const cls = v === "High" ? "bg-red-100 text-red-700 dark:bg-red-950/40 dark:text-red-300"
            : v === "Medium" ? "bg-amber-100 text-amber-800 dark:bg-amber-950/40 dark:text-amber-300"
            : "bg-emerald-100 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300";
  return <span className={`inline-flex rounded-md px-2 py-0.5 text-xs font-medium ${cls}`} data-rating={v}>{v}</span>;
}
